

<template>
  <Layout class="background-component margem-negativa">
    <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="d-flex justify-content-center margem-negativaxxx">
            <img src="../../../assets/images/logo-light-unica2.png" alt="" height="150">
        </div>
        </div>
    </div>

    <div class="row justify-content-end">
      
      <div class="col-md-8 col-lg-6 col-xl-5">
         
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Seja bem vindo(a) !</h5>
                  <p>Faça login para continuar seu trabalho.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logounica.svg" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="Usuário"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="username"
                  type="text"
                  placeholder="Digite seu usuário"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">Email is required.</span>
                  <span v-if="!$v.email.email">Please enter valid email.</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="Senha"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="Informe sua senha"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  Password is required.
                </div>
              </b-form-group>
              <b-form-checkbox
                  class="form-check"
                  id="customControlInline"
                  name="checkbox-1"
                  value="accepted"
                  unchecked-value="not_accepted"
                >
                  Remember me
                </b-form-checkbox>
              <div class="mt-3 d-grid">
                <b-button type="button" variant="primary" class="btn-block" @click="login">Entrar</b-button
                >
              </div>
              <div class="mt-4 text-center">
                <h5 class="font-size-14 mb-3">Entre com suas redes sociais</h5>

                <ul class="list-inline">
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-primary text-white border-primary"
                    >
                      <i class="mdi mdi-facebook"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-info text-white border-info"
                    >
                      <i class="mdi mdi-twitter"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-danger text-white border-danger"
                    >
                      <i class="mdi mdi-google"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock me-1"></i> Esqueceu sua senha?
                </router-link>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            Você não tem uma conta ?
            <router-link
              tag="a"
              to="/register"
              class="fw-medium text-primary"
              >Cria agora</router-link
            >
          </p>
          <p>
            © {{ new Date().getFullYear() }} Criado com
            <i class="mdi mdi-heart text-danger">
            </i> by GW Informática
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
    

  </Layout>
</template>





<script>
import Layout from "../../layouts/auth";
import { ApiAuth } from "./ApiAuth"
import { ApiInv } from "../siscmpfc/inv/ApiInv";
import mensagensMixin from '../../../mixins/mensagensMixin'
export default {

    beforeRouteEnter(routeTo, routeFrom, next) {
        console.log('++++++++dentro da vm++++++++')
        console.log('to: ',routeTo.name)
        console.log('from: ',routeFrom.name)

      /* this.praOndeVai = from.name
      this.praOndeVai = to.name */
      next(vm => {
        //vm.praOndeVai = routeFrom.name
        vm.praOndeVai = routeFrom.path
        if(vm.praOndeVai === null)
          vm.praOndeVai = '/home'
      })
    },

    beforeRouteLeave (to, from, next) {
      console.log('Componente Login saida to: ', to.name)
      console.log('Componente Login saida from: ', from.name)
      next()
    },

    components:{ Layout },
    name:"Login",
    mixins:[mensagensMixin],
    data() {
        return {
            praOndeVai:"/", //home
            isAuthError:"",
            authError:"",
            username:"",
            password:"",
            api: new ApiAuth(),
            ApiInv: new ApiInv,
            empresas:[],
        }
    },
    mounted() {
        //this.listarEmpresas()
        this.$refs.username.focus()
    },
    methods: {
        async login(){
          console.log('----------------------------------------------------------------');
          console.log('Metodo login');
          console.log('----------------------------------------------------------------');
            let username = this.username
            let pass = this.password

            if(username==""){
                this.$swal("Requerido", "Usuário Requerido", "warning")
                return
            }
            if(pass=="" || pass.length <=3){
                this.$swal("Requerido", "Senha Requerida e deve ter no mínimo três caracteres", "warning")
                return
            }

            let token = await this.api.login(username, pass)
            let idU = this.api.decodeToken(token.access)
            console.log("TOKEN:", token)
            console.log("idU->", idU)

            if('access' in token){
              localStorage.setItem("access", token.access)
              localStorage.setItem("refresh", token.refresh)
              localStorage.setItem("user", JSON.stringify({
                id:idU.user_id,
                username: "admin",
                email: "admin@themesbrand.com",
                token: "fake-jwt-token"
              }))
              localStorage.setItem("username", username)

              await this.listarEmpresas()
              console.log('----------------------------------------------------------------');
              console.log('Está logado, agora ver se ele pertence a alguma empresa');
              console.log('----------------------------------------------------------------');
              let empresaDoUsuario = this.username.split('.')[1]
              console.log(this.empresas);
              console.log('empresa do usuário->',empresaDoUsuario);
              const empresa = this.empresas.find(empresa => empresa.login == empresaDoUsuario)
              console.log('empresa-> ', empresa);
              if (!empresa){
                if(idU.user_id > 1){ //1 é o master
                  console.log('empresa do usuário não encontrada');
                  //this.praOndeVai = 'login' //trava no login...só retornando false já resolve
                  this.mensagem("Você foi autenticado no sistema, mais não foi possível identificar sua empresa. Peça para o responsável consertar seu login", `Aviso`, "warning", 10) //mixin
                  return false
                }
              } else {
                this.selecionarEmpresa(empresa);
              }






                //////////////////this.$router.push('/home')
                console.log('pra onde vai: ---------------------------->', this.praOndeVai)
                if(this.praOndeVai == '/')
                    this.praOndeVai = '/' // /home
                this.$router.push(this.praOndeVai)
                //vai ser pego o usuário no nav-bar.vue para mostrar no cabeçalho
                this.$root.$emit("login", username)

            } else if('detail' in token){
                this.mensagemErro(token.detail)
            } else if('error' in token){
                this.mensagemErro(token.error)
            } else {
                this.mensagemErro("Erro Inesperado")
            }





        },

        selecionarEmpresa(empresa){
           /* Decidi deixar as duas formas porque em muitas partes do sistema já é usado localstorage */ 
           let objEmpresa = JSON.stringify(empresa)
           localStorage.setItem("empresa", objEmpresa)
           this.$store.dispatch('company/changeEmpresa', empresa)
           // this.$store.commit('setEmpresa', empresa)
           this.mensagem("", `Bem vindo à ${empresa.nome}`, "success", 3) //mixin
        },

        async listarEmpresas(){
           try {
                this.loading = true
                let empresas = await this.ApiInv.getEmpresas()
                this.empresas = empresas
           } catch (error) {
                //this.mensagem(error, "Houve um erro!", "error") //mixin local
                this.mensagemErro(error) //mixin global no main.js
           } finally{
               this.loading = false
           }
       },
    },
    
}
</script>


<style scoped>

.imagem-fundo {
  background-image: url('../../../assets/images/logo-light-unica2.png');
  /* background-size: cover; */
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center; 
}
body {
  background-image: url('/assets/images/logo-dark-unica.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.margem-negativa{
  margin-top: -80px;
}


.background-component {
  background-image: url("../../../assets/images/unica-fundo.jpeg");
  background-size: cover; /* Redimensiona a imagem para cobrir todo o espaço */
  background-repeat: no-repeat; /* Evita a repetição da imagem */
  background-position: top right;
  min-height: 100vh;
}
</style>
